import {SuiCheckboxModule, SuiPopupModule, SuiSelectModule} from '@angular-ex/semantic-ui';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {GENDERS, STATUS_GROUPS} from '../../../core/constants';
import {Institution} from '../../../core/models/institutions/institutions.model';

import {PopulatedUser} from '../../../core/models/users/users.model';
import {InstitutionsService} from '../../../core/services/institutions/institutions.service';
import {
  onlyAllowedMailDomainsValidator,
} from '../../directives/allowed-mail-domains-validator/allowed-mail-domains-validator.directive';

export interface UserFormValues {
  firstname: string;
  lastname: string;
  statusGroup: string;
  telephone?: string;
  institution: string;
  department: string;
  title?: string;
  gender?: string;
}

@Component({
  selector: 'app-user-profile-form',
  templateUrl: './user-profile-form.component.html',
  styleUrls: ['./user-profile-form.component.css'],
  imports: [
    FormsModule,
    SuiCheckboxModule,
    ReactiveFormsModule,
    SuiSelectModule,
    SuiPopupModule,
  ],
})
export class UserProfileFormComponent implements OnInit {
  @Output() submitForm = new EventEmitter();
  @Output() institutionChanged = new EventEmitter<Institution>();
  @Input() editUser!: PopulatedUser<'institution'>;
  @Input() admin = false;
  @Input() simple = false;

  institutions: Institution[] = [];
  domainInstitutions?: Institution[];

  protected readonly GENDERS = GENDERS;
  protected readonly STATUS_GROUPS = STATUS_GROUPS;

  public userForm!: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private institutionsService: InstitutionsService,
  ) {
  }

  ngOnInit(): void {
    this.institutionsService.getAll({
      select: ['name', 'domains'],
    }).subscribe(result => this.institutions = result.docs);
    this.initForm();

    if (this.editUser) {
      this.updateValues(this.editUser);
    }
  }

  private initForm(): void {
    this.userForm = this.fb.group({
      gender: [''],
      title: [''],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      statusGroup: ['', Validators.required],
      telephone: [''],
      institution: ['', Validators.required],
      department: [''],
    });
  }

  public onSubmit(): void {
    this.submitForm.emit(this.userForm.value);
  }

  private updateValues(user: PopulatedUser<'institution'>): void {
    this.userForm.patchValue({
      gender: user.gender,
      title: user.title,
      firstname: user.firstname,
      lastname: user.lastname,
      statusGroup: user.statusGroup,
      telephone: user.telephone,
      institution: user.institution?._id ?? '',
      department: user.department,
    });

    if (!this.admin) {
      this.institutionsService.getAll({
        withDomain: user.email?.split('@')[1],
        select: ['name'],
      }).subscribe((res) => {
        this.domainInstitutions = res.docs;
      });
    }
  }

  public institutionSelectChange(institutionId: string): void {
    const inst = this.institutions.find(i => i._id === institutionId);
    if (inst) {
      this.editUser.institution = inst;
      this.userForm.controls.department.setValue(null);
      this.institutionChanged.emit(inst);
    }
  }

  public submit(): UserFormValues {
    return this.userForm.value;
  }
}
